import {Injectable} from '@angular/core';

import {Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import {filter, map} from 'rxjs/operators';
import {ConfigurationService} from './core/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private configurationService: ConfigurationService,
  ) {

  }

  public setDocumentTitle(titleParts: string []) {
    const configuration = this.configurationService.getConfiguration();

    const siteTitle = configuration.siteInfo.siteTitle;
    let title;
    if (!titleParts) {
      title = siteTitle;
      // title += ' - Digitizing Water Finance'; // special case for Home page - modeled after The New York Times
    } else {
      title = titleParts[0];
      if (titleParts.length > 1) {
        title += ' - ' + titleParts[1];
      }
      title += ' | ' + siteTitle ;
    }
    this.titleService.setTitle(title);
  }

  public initDynamicDocumentTitle() {
    // this.appService.setDocumentTitle();

    // Taken in part from here: https://blog.bitsrc.io/dynamic-page-titles-in-angular-98ce20b5c334

    this.router
      .events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child.firstChild) {
          child = child.firstChild;
        }
        if (child.snapshot.data.title) {
          const title = [child.snapshot.data.title];
          if (child.snapshot.data.titleParent) {
            title.push(child.snapshot.data.titleParent);
          }
          return title;
        }
        return undefined;
      })
    ).subscribe((titleParts: string[]) => {
      this.setDocumentTitle(titleParts);
    });

  }

}
